import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  background: {
    background: ({ isBackgroundVisible }) =>
      isBackgroundVisible ? theme.palette.primary.main : 'transparent',
  },
  footerForm: {
    '& .MuiInputBase-input:-webkit-autofill': {
      boxShadow: `inset 0 0 0 1000px ${theme.palette.primary.main}`,
    },
    '& .MuiInputBase-input:autofill': {
      boxShadow: `inset 0 0 0 1000px ${theme.palette.primary.main}`,
    },
  },
  successMessage: {
    zIndex: theme.zIndex.xRayWrapper,
    [theme.breakpoints.up('sm')]: {
      minHeight: '545px',
    },
    [theme.breakpoints.up('md')]: {
      minHeight: '328px',
    },
  },
  successHeading: {
    marginBottom: theme.spacing(4),
  },
  footerAnimationStyle: {
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
  },
  successMessageContainer: {
    position: 'relative',
    textAlign: 'center',
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    [theme.breakpoints.down('xs')]: {
      minHeight: '620px',
    },
  },
  waitlistWrapper: {
    background: 'transparent',
    display: 'flex',
    flexFlow: 'row wrap-reverse',
    boxSizing: 'border-box',
    padding: theme.spacing(9, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(9.75, 12),
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
      alignItems: 'center',
      padding: theme.spacing(14.5, 12),
    },
  },
  waitingListRow: {
    maxWidth: '100%',
  },
  waitingListDescription: {
    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing(12),
    },
    [theme.breakpoints.up('lg')]: {
      marginRight: theme.spacing(15),
    },
    '&>*': {
      marginBottom: theme.spacing(4),
    },
    '& form': {
      marginTop: theme.spacing(1),
    },
  },
  waitingListTitle: {
    textShadow: `4px 4px ${theme.palette.text.secondary}`,
    fontWeight: 700,
    color: theme.palette.text.primary,
    [theme.breakpoints.up('md')]: {
      '[lang=ar] &': {
        letterSpacing: -2,
      },
    },
  },
  ctaDescription: {
    marginBottom: 0,
    '& p:last-child': {
      marginBottom: 0,
    },
  },
  formCta: {
    marginTop: '1.3rem',
  },
  footerFormLottie: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      height: '579px',
    },
  },
}))
